import BarekamInput from "./barekam-input";

export default BarekamInput;
